export const homeFAQ = [
  {
    question: "黑料在线是什么平台？",
    answer: "黑料在线是专业的娱乐爆料聚合平台，每日精选全网热门八卦、网红反差大瓜、明星绯闻和社会热点，为吃瓜群众提供最新最全的在线吃瓜入口。",
  },
  {
    question: "平台上的爆料内容真实吗？",
    answer: "黑料在线所有内容均来自公开渠道和知情人士的爆料，我们力求信息真实可靠，但部分内容涉及未经证实的传闻，仅供娱乐参考，不代表本平台立场。",
  },
  {
    question: "如何投稿爆料？",
    answer: "如果您有独家爆料信息，可以通过网站底部的联系方式与我们取得联系。我们会对所有爆料信息进行核实，保护爆料人隐私。",
  },
  {
    question: "内容更新频率是怎样的？",
    answer: "黑料在线承诺7×24小时不打烊更新，每天早中晚三个时段推送最新爆料，重大突发事件将第一时间跟进报道。",
  },
  {
    question: "如何追踪我感兴趣的爆料话题？",
    answer: "您可以通过分类浏览找到感兴趣的话题类别，每个文章页面底部也会推荐相关阅读，帮助您持续追踪同类爆料动态。",
  },
];